<template>
  <layout>
    <div class="container mt-4 mb-4">
      <vue-advanced-chat
        ref="chatWindow"
        :height="screenHeight"
        :styles="JSON.stringify(styles)"
        :current-user-id="currentUserId"
        :room-id="roomId"
        :rooms="JSON.stringify(rooms)"
        :rooms-loaded="roomsLoaded"
        :messages="JSON.stringify(messages)"
        :messages-loaded="messageLoaded"
        :room-message="roomMessage"
        :message-actions="JSON.stringify(messageActions)"
        :show-new-messages-divider="showNewMessageDivider"
        :single-room="singleRoom"
        :show-footer="showFooter"
        @fetch-messages="fetchMessages($event.detail[0])"
        @send-message="sendMessage($event.detail[0])"
        @delete-message="deleteMessage($event.detail[0])"
        @open-file="openFile($event.detail[0])"
        @room-action-handler="menuActionHandler($event.detail[0])"
        @menu-action-handler="menuActionHandler($event.detail[0])"
        @message-action-handler="menuActionHandler($event.detail[0])"
      />
    </div>
  </layout>
</template>

<script>
import { mapState } from "vuex";
import Layout from "../workspace/Layout.vue";
import chatServer from "../../server/chat";
import accessServer from "../../server/accesses";
import { formatDateTimeMysql } from "../../helpers/date";
import chatSignalRConnection from "../../signalr/chat";
import { register } from "vue-advanced-chat";
register();

export default {
  name: "Messages",
  components: {
    Layout
  },
  props: ["showing"],
  data() {
    return {
      rooms: [],
      roomId: null,
      roomsLoaded: true,
      roomsLoadedCount: 0,
      selectedRoom: null,
      messages: [],
      messageLoaded: true,
      roomMessage: "",
      lastLoadedMessage: null,
      previousLastLoadedMessage: null,
      typingMessageCache: "",
      messageActions: [
        {
          name: "delete",
          title: "Delete Message"
        }
      ],
      styles: { container: { borderRadius: "4px" } },
      messagesInterval: null,
      showNewMessageDivider: false,
      singleRoom: true,
      showFooter: true,
      accessEntry: null,
      currentUserId: null
    };
  },
  async mounted() {
    this.currentUserId = this.user.Id;
    this.populateRoom();
    this.accessEntry = await accessServer.queryById(this.user.Id);

    if (this.config.patientPortalDisableChatReply) {
      this.showFooter = false;
    }

    await this.fetchMessages();

    chatSignalRConnection.initialize(
      "chat",
      this.$store.state.session.systemSettings.signalRAppUrl
    );

    chatSignalRConnection.start();

    chatSignalRConnection.on("NewPortalAppChatMessage", async result => {
      if (
        (result.receivers.includes(this.user.Id) ||
          result.receivers.includes(this.user.PatientId)) &&
        result.tenantName === this.config.currentTenant
      ) {
        await this.fetchMessages();
      }
    });
  },
  destroyed() {
    chatSignalRConnection.stop();
    this.messages = null;
  },

  methods: {
    populateRoom() {
      this.roomLoaded = false;
      this.rooms = [];

      this.rooms = [
        {
          roomId: "1234",
          roomName: "",
          avatar: "",
          users: [
            {
              _id: this.user.Id,
              username: this.user.Name
            }
          ],
          typingUsers: [this.user.Id],
          lastMessage: null
        }
      ];
      this.roomId = this.rooms[0].roomId;
      this.roomsLoadedCount = this.rooms.length;

      this.roomLoaded = true;
    },
    async updateChatUserPortalUser() {
      const caseLoad = await chatServer.getCaseLoad(
        this.accessEntry.data.patient.id
      );
      if (caseLoad.data.length > 0) {
        caseLoad.data.forEach(async item => {
          await chatServer.create({
            PatientId: this.user.PatientId,
            PortalUserId: this.accessEntry.data.portalUser.id,
            UserId: item.user.id
          });
        });
      }
    },
    async fetchMessages() {
      this.messageLoaded = false;
      if (this.previousLastLoadedMessage && !this.lastLoadedMessage) {
        this.messagesLoaded = true;
        return;
      }
      await chatServer
        .findById(this.accessEntry.data.portalUser.id, this.user.PatientId)
        .then(response => {
          const msgs = [];
          if (response.data.length > 0) {
            response.data.forEach(message => {
              const formattedMessage = this.formatMessage(message);
              msgs.unshift(formattedMessage);
            });

            if (this.lastLoadedMessage) {
              this.previousLastLoadedMessage = this.lastLoadedMessage;
            }
            this.lastLoadedMessage = this.formatMessage(
              response.data[response.data.length - 1]
            );
          }

          setTimeout(() => {
            this.messages = Object.assign([], msgs);
            this.messagesLoaded = true;
          }, 0);
        });

      this.rooms[0].lastMessage = this.lastLoadedMessage;
      this.messageLoaded = true;
    },
    formatMessage(message) {
      var files = [];
      if (message.fileId) {
        let file = JSON.parse(JSON.parse(JSON.stringify(message.fileData)));
        let link = chatServer.downloadUrl(message.fileId);
        files = [
          {
            name: file.name,
            size: file.size,
            type: file.extension,
            audio: file.audio ? file.audio : false,
            duration: file.audio ? file.duration : null,
            url: link
          }
        ];
      }
      const formattedMessage = {
        ...message,
        ...{
          senderId:
            message.senderType == "PortalUser"
              ? message.portalUser.id
              : message.senderUser?.id,
          _id: message.id,
          content: message.message,
          seconds: this.formatTimeOnly(message.dateTime).seconds,
          timestamp: this.formatTimeOnly(message.dateTime),
          date: this.formatDateOnly(message.dateTime),
          username:
            message.senderType == "PortalUser"
              ? message.portalUser.name
              : message.senderUser
              ? this.formatUser(message.senderUser)
              : "",
          distributed: true,
          lastMessage: {
            ...message.lastMessage,
            senderId:
              message.senderType == "PortalUser"
                ? message.portalUser.id
                : message.senderUser?.id
          },
          system: false,
          disableActions: false,
          disableReactions: true,
          files: files,
          new: false,
          seen: message.seen
        }
      };

      return formattedMessage;
    },
    async sendMessage({ content, files }) {
      let message = {
        SenderType: 1,
        PatientId: this.user.PatientId,
        SenderUserId: null,
        PortalUserId: this.accessEntry.data.portalUser.id,
        Message: content,
        DateTime: formatDateTimeMysql(new Date()),
        Relationship: this.accessEntry.data.relationship
      };

      if (files?.length > 0) {
        let messageFiles = [];
        let messageFilesData = "";
        for (let index = 0; index < files.length; index++) {
          messageFiles.push(this.getFileToUpload(files[index]));
        }
        messageFilesData = JSON.stringify(this.formattedFiles(files));
        message.Files = messageFiles;
        message.FilesData = messageFilesData;
      }

      await chatServer.createMsg(message);
      await this.updateChatUserPortalUser();
      const receivers = await chatServer.getReceivers();
      chatServer.sendToMainApp(
        {
          tenantName: this.config.currentTenant,
          receivers: receivers.data
        },
        this.config.signalRAppUrl
      );
      await this.fetchMessages();
    },
    getFileToUpload(file) {
      let metadata = {
        type: file.type
      };
      return new File([file.blob], file.name + "." + file.extension, metadata);
    },
    menuActionHandler({ action, message }) {
      switch (action.name) {
        case "delete":
          this.deleteMessage(message);
          break;
      }
    },
    async deleteMessage(message) {
      await chatServer.delete(message._id);
      this.fetchMessages({});
    },
    formattedFiles(files) {
      const formattedFiles = [];
      files.forEach(file => {
        const messageFile = {
          name: file.name,
          size: file.size,
          type: file.type,
          extension: file.extension || file.type,
          url: file.url || file.localUrl
        };
        if (file.audio) {
          messageFile.audio = true;
          messageFile.duration = file.duration;
        }
        formattedFiles.push(messageFile);
      });
      return formattedFiles;
    },
    openFile({ file }) {
      window.open(file.file.url, "_blank");
    }
  },

  computed: {
    ...mapState("session", {
      config: state => state.systemSettings,
      user: state => state.user
    }),
    userFormatted() {
      return this.user ? this.formatUser(this.user) : "";
    },
    screenHeight() {
      return "calc(100vh - 205px)";
    }
  },
  watch: {
    showing: async function(newValue) {
      if (newValue) {
        await this.fetchMessages({});
      }
    }
  }
};
</script>

<style lang="scss">
.card-header {
  padding: 0 15px 12px;
  background-color: transparent;
  border: none;
}

.tab-pane {
  padding: 20px 0;
}
</style>
